import { render } from "./LegacyMktReportSettings.vue?vue&type=template&id=f6e61f62"
import script from "./LegacyMktReportSettings.vue?vue&type=script&lang=js"
export * from "./LegacyMktReportSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__